import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {},
  roles: null,
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    adminLogin: (state, action) => {
      state.user = action.payload;
      state.roles = 2;
    },
    userLogin: (state, action) => {
      state.user = action.payload;
      state.roles = 1;
    },
    logout: (state) => {
      state.user = {};
      state.roles = 0;
    },
  },
});

export const { adminLogin, userLogin, logout } = roleSlice.actions;

export const roleReducer = roleSlice.reducer;
export default roleSlice.reducer;
